import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';
import {
  TEAM_LEAGUE_TABLE_PAGE_REQUEST,
  TEAM_LEAGUE_TABLE_PAGE_RECEIVE,
  TEAM_LEAGUE_TABLE_PAGE_FAILURE,
  PAGE_DATA_LOAD,
} from '../../action-types';

export const fetchLeagueTablePageData = (clubId, teamId, request) => async (dispatch) => {
  try {
    dispatch({ type: TEAM_LEAGUE_TABLE_PAGE_REQUEST, payload: { clubId, teamId } });
    const pageKey = new PageKey(clubId, 'league_tables', { teamId });
    const pageData = await PageDataLoader.getPageData(
      new PageKey(clubId, 'league_tables', { teamId }),
      request,
    );
    const { seasons, tables } = pageData.data;

    dispatch({
      type: TEAM_LEAGUE_TABLE_PAGE_RECEIVE,
      payload: { clubId, teamId, seasons, tables },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }
    dispatch({
      type: TEAM_LEAGUE_TABLE_PAGE_FAILURE,
      payload: { clubId, teamId, statusCode, error },
    });
    return { error };
  }
};
